module.exports = __webpack_public_path__ + "assets/img/guarantee.573a304b.svg";